module.exports = __webpack_public_path__ + "static/media/game-foreground.c53d3282.png";